import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Select,
  Spinner,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaPlus, FaClock, FaBook } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const colors = ["#FCEBD8", "#D8E8F4", "#F0F9E8", "#E6D4F1", "#FFF3E6"];

const ClassTimetable = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formData, setFormData] = useState({
    day: "",
    period: "",
    startTime: "",
    endTime: "",
    subject: "",
    teacher: "",
  });

  const [days, setDays] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [timetableData, setTimetableData] = useState([]);
  const userId = sessionStorage.getItem("user_id");

  useEffect(() => {
    fetchDays();
    fetchSubjects();
    fetchTimetable(); // Fetch timetable when component mounts
  }, []); // Empty dependency array to run only on mount

  const fetchDays = () => {
    fetch(`${BASE_URL}/admin/timetable/day_master.php`)
      .then((response) => response.json())
      .then((data) => {
        setDays(Array.isArray(data.data) ? data.data : []);
      })
      .catch((error) => {
        console.error("Error fetching days:", error);
        setDays([]);
      });
  };

  const fetchSubjects = () => {
    fetch(`${BASE_URL}/staff/timetable/subject_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pass: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("====================================");
        console.log(data);
        console.log("====================================");
        setSubjects(Array.isArray(data.subjects) ? data.subjects : []);
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
      });
  };

  const fetchTimetable = () => {
    fetch(`${BASE_URL}/staff/timetable/list_timetable.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pass: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Timetable data:", data); // Check this log
        setTimetableData(data.data || []); // Ensure this matches your API response
      })
      .catch((error) => {
        console.error("Error fetching timetable:", error);
      });
  };

  useEffect(() => {
    if (formData.day) {
      fetchPeriods();
    }
  }, [formData.day]);

  const fetchPeriods = () => {
    fetch(`${BASE_URL}/staff/timetable/available_periods.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        day_id: formData.day,
        pass: userId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setPeriods(
          Array.isArray(data.availablePeriods) ? data.availablePeriods : []
        );
      })
      .catch((error) => {
        console.error("Error fetching periods:", error);
        setPeriods([]);
      });
  };

  const handleSubjectChange = (e) => {
    const subjectId = e.target.value;
    console.log("Selected Subject ID:", subjectId); // This should match the expected ID

    setFormData({ ...formData, subject: subjectId });

    fetch(`${BASE_URL}/admin/timetable/depending_teachers.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subject_id: subjectId }), // Ensure the correct ID is being passed here
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Teachers data:", data);
        if (Array.isArray(data.data)) {
          setTeachers(data.data); // Correctly set teachers if data is found
        } else {
          console.error("Unexpected response format:", data);
          setTeachers([]); // If no data is returned, reset teachers list
        }
      })
      .catch((error) => console.error("Error fetching teachers:", error));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const { day, period, startTime, endTime, subject, teacher } = formData;

    const inputData = {
      pass: userId,
      day_id: day,
      period: period,
      start_time: startTime,
      end_time: endTime,
      subject_id: subject,
      staff_id: teacher,
    };
    console.log("time table object data:", inputData);

    fetch(`${BASE_URL}/staff/timetable/create_timetable.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(inputData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);
        alert(data.message);
        if (data.success) {
          setMessage({ type: "success", text: data.message });
          setFormData({
            day: "",
            period: "",
            startTime: "",
            endTime: "",
            subject: "",
            teacher: "",
          });
          onClose();
          fetchTimetable(); // Refresh timetable after submission
        } else {
          setMessage({ type: "error", text: data.message });
        }
      })
      .catch((error) => {
        console.error("Error submitting timetable:", error);
        setMessage({ type: "error", text: "Failed to submit timetable" });
      });
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        {/* <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px" }}>TimeTable</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md"
                backgroundColor="white"
                fontSize="11px"
                onClick={fetchTimetable} // Refresh timetable on button click
              >
                <FaSync color="#515B73" />
              </Button>

              <Flex gap={2} className="export-dropdown">
                <Button
                  className="export-button"
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>

                <Button
                  leftIcon={<FaPlus />}
                  colorScheme="teal"
                  onClick={onOpen}
                  isDisabled={userId}
                >
                  Add
                </Button>
              </Flex>
            </div>
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Time Table</span> / <span>Class</span>
          </div>
        </div> */}
        <Box
          // This will replace 'teacher-list-container' and 'header' wrappers
          px={{ base: 4, md: 8, lg: 10 }} // Responsive horizontal padding
          py={{ base: 5, md: 6 }}
          // borderBottom="1px solid"
          // borderColor="gray.200"
          // bg="gray.50"
        >
          {/* 1. Main Header Flex: Title/Breadcrumbs (Left) vs Buttons (Right) */}
          <Flex
            justify="space-between"
            align={{ base: "flex-start", sm: "center" }} // Align buttons better on small screens
            direction={{ base: "column", sm: "row" }} // Stack on mobile
            gap={{ base: 4, md: 0 }} // Gap when stacked
          >
            {/* Left Block: Heading and Breadcrumbs */}
            <Box mb={{ base: 3, sm: 0 }}>
              {/* Heading */}
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="bold"
                mb={1}
              >
                 TimeTable
              </Text>

              {/* Breadcrumbs - replacing the old 'breadcrumb' div */}
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.600">
                <span>Staff</span>
                <Text as="span" mx={1}>
                  /
                </Text>
                <span>Time Table</span>
                <Text as="span" mx={1}>
                  /
                </Text>
                <Text as="span" fontWeight="semibold">
                  Class
                </Text>
              </Text>
            </Box>

            {/* Right Block: Action Buttons - replacing 'action-buttons' div */}
            <Flex
              gap={2}
              wrap="wrap" // Allow buttons to wrap to the next line if space is limited
              justify={{ base: "stretch", sm: "flex-end" }} // Stretch buttons on mobile
              w={{ base: "100%", sm: "auto" }} // Full width on mobile, auto on desktop
            >
              {/* Refresh Button */}
              <Button
                onClick={fetchTimetable} // Assuming fetchTimetable is passed or defined
                boxShadow="md"
                backgroundColor="white"
                color="#515B73"
                size="md" // Use standard Chakra size
                minW={{ base: "30%", sm: "auto" }} // Responsive min width
                flexGrow={1} // Allow growing to fill space when needed
              >
                <FaSync />
              </Button>

              {/* Print PDF Button */}
              <Button
                backgroundColor="white"
                boxShadow="md"
                color="#515B73"
                size="md"
                leftIcon={<FaPrint />}
                minW={{ base: "30%", sm: "auto" }}
                flexGrow={1}
              >
                Print PDF
              </Button>

              {/* Add Button */}
              <Button
                leftIcon={<FaPlus />}
                colorScheme="teal"
                onClick={onOpen} // Assuming onOpen is defined
                isDisabled={userId} // Assuming userId is defined
                size="md"
                minW={{ base: "30%", sm: "auto" }}
                flexGrow={1}
              >
                Add
              </Button>
            </Flex>
          </Flex>
        </Box>

        <Box p={6}>
          <Box className="sb" p={4}>
            <Text fontSize="lg">Class Timetable</Text>
          </Box>
          <Grid
            templateColumns={{
              base: "repeat(2, 1fr)",
              sm: "repeat(3, 1fr)",
              md: "repeat(5, 1fr)",
            }} // Responsive columns
            gap={6}
            mt={1}
            p={4}
            className="sb2"
          >
            {days.map((day) => (
              <GridItem key={day.id}>
                <Text fontWeight="bold" mb={3}>
                  {day.day}
                </Text>
                {timetableData
                  .filter((slot) => slot.day_id === day.id)
                  .map((slot, j) => (
                    <Box
                      key={j}
                      bg={colors[Math.floor(Math.random() * colors.length)]}
                      p={4}
                      borderRadius="md"
                      mb={4}
                    >
                      <Flex alignItems="center" mb={2}>
                        <Icon as={FaClock} color="gray.500" mr={2} />
                        <Text>
                          {slot.start_time} - {slot.end_time}
                        </Text>
                      </Flex>
                      <Flex alignItems="center" mb={2}>
                        <Icon as={FaBook} color="gray.500" mr={2} />
                        <Text>{slot.subject}</Text>
                      </Flex>
                      <Flex alignItems="center">
                        <Avatar
                          size="xs"
                          name={slot.staff_name}
                          src={slot.staff_photo}
                          mr={2}
                        />
                        <Text>{slot.staff_name}</Text>
                      </Flex>
                    </Box>
                  ))}
              </GridItem>
            ))}
          </Grid>
        </Box>

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add Class Timetable</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Day</FormLabel>
                <Select
                  placeholder="Select Day"
                  name="day"
                  value={formData.day}
                  onChange={handleInputChange}
                >
                  {days.map((day) => (
                    <option key={day.id} value={day.id}>
                      {day.day}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Period</FormLabel>
                <Select
                  placeholder="Select Period"
                  name="period"
                  value={formData.period}
                  onChange={handleInputChange}
                >
                  {periods.map((period) => (
                    <option key={period.id} value={period.id}>
                      {period}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Start Time</FormLabel>
                <Input
                  placeholder="Start Time"
                  name="startTime"
                  value={formData.startTime}
                  onChange={handleInputChange}
                  type="time"
                />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>End Time</FormLabel>
                <Input
                  placeholder="End Time"
                  name="endTime"
                  value={formData.endTime}
                  onChange={handleInputChange}
                  type="time"
                />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Subject</FormLabel>
                <Select
                  placeholder="Select Subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleSubjectChange}
                >
                  {subjects.map((subject) => (
                    <option key={subject.subject_id} value={subject.subject_id}>
                      {subject.subject_name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Teacher</FormLabel>
                <Select
                  placeholder="Select Teacher"
                  name="teacher"
                  value={formData.teacher}
                  onChange={handleInputChange}
                >
                  {teachers.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={handleSubmit}
                isLoading={loading}
              >
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    </Box>
  );
};

export default ClassTimetable;
